/**
 * Tool name enum-like const object.
 * These are the tool names used across the AI system.
 */
export const ALINE_TOOL_NAMES = {
  askUser: 'askUser',
  attachUploadedFileAsVersion: 'attachUploadedFileAsVersion',
  commentOnTaskTool: 'commentOnTask',
  completeTaskTool: 'completeTask',
  completeWorkflowTool: 'completeWorkflow',
  connectExternalAccount: 'connectExternalAccount',
  createReportTool: 'createReport',
  createSkillTool: 'createSkill',
  documentBaseAnalysisTool: 'documentBaseAnalysisTool',
  enableExternalTools: 'enableExternalTools',
  generatePlaybookTool: 'generatePlaybook',
  getFullDocumentTool: 'getFullDocumentTool',
  getTaskAgentThreadTool: 'getTaskAgentThread',
  getTaskTool: 'getTask',
  getWebPageContents: 'getWebPageContents',
  listTasksTool: 'listTasks',
  loadSkillTool: 'loadSkill',
  queryDocumentTool: 'queryDocument',
  readIntakeFormTool: 'readIntakeForm',
  readPlaybookTool: 'readPlaybook',
  readSkillResourceTool: 'readSkillResource',
  readSkillTool: 'readSkill',
  reassignTaskTool: 'reassignTask',
  replyInChannelThreadTool: 'replyInChannelThread',
  reportAnalysisTool: 'reportAnalysisTool',
  runExtractionQuestionsTool: 'runExtractionQuestions',
  runPlaybookTool: 'runPlaybook',
  searchPlaybooksTool: 'searchPlaybooks',
  searchSkillResourcesTool: 'searchSkillResources',
  searchSkillsTool: 'searchSkills',
  searchTool: 'searchTool',
  selectDocuments: 'selectDocuments',
  semanticSearch: 'semanticSearch',
  updateSkillTool: 'updateSkill',
  workflowAssignTask: 'workflowAssignTask',
  workflowCollectIntakeForm: 'workflowCollectIntakeForm',
  workflowCollectLaunchInfo: 'workflowCollectLaunchInfo',
  workflowCreateDraft: 'workflowCreateDraft',
  workflowLaunchTemplate: 'workflowLaunchTemplate',
  workflowManagePhases: 'workflowManagePhases',
  workflowReadIntakeForm: 'workflowReadIntakeForm',
  workflowReadResource: 'workflowReadResource',
  workflowSearchExisting: 'workflowSearchExisting',
  workflowSearchTemplates: 'workflowSearchTemplates',
  workflowUpdateIntakeForm: 'workflowUpdateIntakeForm',
} as const;

/**
 * Union type of all tool names.
 */
export type AlineToolName = (typeof ALINE_TOOL_NAMES)[keyof typeof ALINE_TOOL_NAMES];
